import { render, staticRenderFns } from "./Oferta.vue?vue&type=template&id=aa6248bc"
import script from "./Oferta.vue?vue&type=script&lang=js"
export * from "./Oferta.vue?vue&type=script&lang=js"
import style0 from "./Oferta.vue?vue&type=style&index=0&id=aa6248bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports